import { ALL_FILTER_VALUE } from '@/app-shell/settings/organization/atoms/organizationAtoms';
// migration-allow(family-importers): the host reads the organization teams for the moved teams selection
import { useCombinedOrganizationInfo } from '@/hooks/query/useCombinedOrganizationInfo';
import { TeamsSelection } from '@heidi/templates';
import { type ComponentProps } from 'react';

type Props = Omit<ComponentProps<typeof TeamsSelection>, 'host'>;

export const TeamsSelectionHost = (props: Props) => {
  const { orgTeams } = useCombinedOrganizationInfo();

  return (
    <TeamsSelection
      {...props}
      host={{
        orgTeams,
        allFilterValue: ALL_FILTER_VALUE,
      }}
    />
  );
};
